import type { FC } from 'react';
import { useCallback, useState } from 'react';
import { useEmployeeCardPin } from '@pflegenavi/frontend/api-nursing-home';
import { CardPinFieldView } from './CardPinFieldView';

export interface CardPinFieldProps {
  cardId: string;
}

// The PIN is only requested once the user asks to reveal it.
export const CardPinField: FC<CardPinFieldProps> = ({ cardId }) => {
  const [revealed, setRevealed] = useState(false);
  const {
    data: pin,
    isFetching,
    isError,
    refetch,
  } = useEmployeeCardPin(cardId, revealed);

  const handleToggle = useCallback(() => {
    if (isError) {
      void refetch();
      return;
    }
    setRevealed((current) => !current);
  }, [isError, refetch]);

  return (
    <CardPinFieldView
      revealed={revealed}
      pin={pin}
      loading={isFetching}
      error={isError}
      onToggle={handleToggle}
    />
  );
};
